import request from "@/utils/request";

// 获取过磅列表
export function getHistoryList(params) {
  return request.post("/weighbridge/list", params).then(({ data }) => {
    const { msg, data: queryData, code } = data;
    const { records, total } = queryData;
    return { data: { msg, data: { items: records, total }, code } };
  });
}

export function edit(payload) {
  return request.post("/weighbridge/updateWrById", payload);
}

export function del(payload) {
  return request.post("/weighbridge/deleteWrById/" + payload.id);
}

// 人脸闸机放行
export function updateOne(params) {
  return request.get("/equip/openRail", { params });
}
